/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetEnvironmentReleasesPathParams = NonNullable<
  operations['internalGetEnvironmentReleases']['parameters']['path']
>;

export type InternalGetEnvironmentReleasesQueryParams = NonNullable<
  operations['internalGetEnvironmentReleases']['parameters']['query']
>;

export interface Input extends InternalGetEnvironmentReleasesPathParams {
  apiVersion?: string;
  query?: InternalGetEnvironmentReleasesQueryParams;
}

export async function internalGetEnvironmentReleases(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/flags/{flagKey}/environments/{environmentKey}/releases', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
